var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1288 3.60001H4.86842C3.83804 3.60001 3 4.4353 3 5.46842V17.9731C3 19.0035 3.83529 19.8415 4.86842 19.8415H19.1316C20.162 19.8415 21 19.0062 21 17.9731V5.46568C20.9973 4.4353 20.162 3.60001 19.1288 3.60001ZM19.8872 17.168C19.7278 17.3768 19.4695 17.484 19.2085 17.484H12.5701H4.78873C4.52771 17.484 4.26942 17.3768 4.11006 17.168C3.90398 16.8987 3.88475 16.5498 4.04961 16.264L7.58037 10.1477C7.726 9.89217 7.98977 9.74105 8.28377 9.74105C8.57777 9.74105 8.8443 9.89492 8.98718 10.1477L10.1604 12.181L13.1691 6.9659C13.3148 6.71312 13.584 6.55925 13.8725 6.55925C14.161 6.55925 14.4331 6.71312 14.5759 6.9659L19.9449 16.264C20.1125 16.5498 20.0933 16.896 19.8872 17.168Z",
    fill: "#187DFD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.050bf950e2c0e516ff2e97c176fa4655.svg";
export { ForwardRef as ReactComponent };